/**
 * app.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */



// Import all the third party stuff
import React from 'react';
import { createRoot } from 'react-dom/client';

import { browserHistory, Router } from 'react-router';


import AppGenerated from 'containers/AppGenerated';
import PublicViewEvent from 'containers/PublicViewEvent';

const domNode = document.getElementById('app') as HTMLDivElement;
const root = createRoot(domNode);

const routes = {
  path: '/',
  component: AppGenerated,
  indexRoute: { component: PublicViewEvent },
  childRoutes: [
    { path: ':pageSlug', component: PublicViewEvent },
    { path: ':pageSlug/:secondSlug', component: PublicViewEvent },
    { path: 'location/:chapterSlug', component: PublicViewEvent },
    { path: 'location/:chapterSlug/:pageSlug', component: PublicViewEvent },
    { path: 'location/:chapterSlug/:pageSlug/:secondSlug', component: PublicViewEvent },
    { path: 'events/:organizationSlug/:eventSlug', component: PublicViewEvent },
    { path: 'events/:organizationSlug/:eventSlug/:pageSlug', component: PublicViewEvent }
  ]
}

root.render(<Router routes={routes} history={browserHistory} />);

